import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RechercheComponent } from '../recherche/recherche.component';
import * as globalUrls from '../services/globalVariables';
@Component({
  selector: 'app-avt-machine',
  templateUrl: './avt-machine.component.html',
  styleUrls: ['./avt-machine.component.scss'],
})
export class AvtMachineComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public router: Router
  ) {}
  exist: boolean = true;
  disabled: boolean = false;
  showDoc: boolean = false;
  listeTypeCarburant = [];
  listeMAchineMultimedia = [];
  listeMAchineIndustriels = [];
  listeMAchineBTP = [];
  listeAllSalleIsLoadet: boolean = false;
  listeAllSalle = [];
  listeMachine_Type = this.generalService.listeMachine_Type;
  machine;
  index: number = 0;
  // Angular Editor Supprimer
  // editorConfig  = JSON.parse(JSON.stringify(this.generalService.editorConfig)) ;
  typeTrs: string;
  param_code: string;
  initMachine;
  listeCollaborateurs = [];
  @ViewChild('collaborateurComponent', { static: false })
  collaborateurComponent: RechercheComponent;
  ngOnInit() {
    this.machine = {};
    this.readParamUrl();
    this.getTypeCarburant();
    this.getTypeMAchineBTP();
    this.getTypeMAchineIndustriels();
    this.getTypeMAchineMultimedia();
    this.getTypeSalle();
  }
  getListeCollaborateur() {
    this.generalService
      .rechercheTable(this.generalService.url + 'avtperso&param=0')
      .subscribe((data) => {
        this.listeCollaborateurs = this.generalService.sort(data, 'Perso_Nom');
        var coll = data.find((c) => {
          return c.Perso_Matricule == this.machine.Perso_Matricule;
        });
        this.collaborateurComponent.parentVal = coll ? coll.Perso_Nom : '';
      });
  }
  blurCollaborateur(event) {
    this.machine.Perso_Matricule = event;
  }
  getMachine(url: string) {
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.initMachine = data;
      this.machine = this.initMachine.Machine[0];
      // pour Machine_Famille1 == 1 => vehycule¨, equipent multimedia, equipent industruell, equipent BT
      // pour Machine_Famille1 == 2 => sale ,atelier
      this.machine.Machine_Famille1 = '1';
      if (this.typeTrs == '1') {
        this.machine.Machine_Type = 1;
      }
      this.getListeCollaborateur();
    });
  }
  enregistrer(form) {
    if (form.form.valid) {
      this.exist = false;
      this.generalService
        .rechercheTable(this.generalService.url + 'avtMachineT&param=1')
        .subscribe((data) => {
          var findMachine = data.find((machine) => {
            return (
              (machine.Machine_Serie == this.machine.Machine_Serie ||
                machine.Machine_Lib == this.machine.Machine_Lib) &&
              machine.Machine_Code != this.machine.Machine_Code
            );
          });
          if (!findMachine) {
            this.generalService.enregisterTable(this.initMachine).subscribe(
              (data) => {
                this.init();
                this.exist = true;
                this.generalService.dialogSuccess('Enregistré', true);
              },
              (erro) => {
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
          } else {
            this.generalService.dialogSuccess(
              'Cette ressource matérielle existe déjà',
              false
            );
            this.exist = true;
          }
        });
    }
  }
  tabChanged() {
    if (this.index == 2) this.showDoc = true;
  }
  getTypeCarburant() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MACH01')
      .subscribe((data) => {
        this.listeTypeCarburant = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  getTypeMAchineMultimedia() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MACH02')
      .subscribe((data) => {
        this.listeMAchineMultimedia = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  getTypeMAchineIndustriels() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MACH03')
      .subscribe((data) => {
        this.listeMAchineIndustriels = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  getTypeMAchineBTP() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MACH04')
      .subscribe((data) => {
        this.listeMAchineBTP = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  getTypeSalle() {
    this.listeAllSalle = this.generalService.typeSalle;
    this.listeAllSalleIsLoadet = true;
    // this.generalService.rechercheTable(globalUrls.urlParametre+"&val=SALL01").subscribe(data =>
    // {
    //   this.listeAllSalle = this.generalService.sort(data.DiverSys,"DiverSys_Titre");
    //   this.listeAllSalleIsLoadet = true;
    // });
  }
  init() {
    var url: string = globalUrls.urlMachine;
    if (this.typeTrs == '2' || this.typeTrs == '3') {
      url += '&val=' + this.param_code;
    }
    if (this.typeTrs == '3') {
      this.disabled = true;
      // Angular Editor Supprimer
      // this.editorConfig.editable = !this.disabled
    }
    this.getMachine(url);
  }
  goToListeMachine() {
    this.generalService.popupCenter('/w/avt/liste/machine/1');
    //window.open(location.origin+ "/avt/liste/machine/1", '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes')
    // this.generalService.fenetreAvtListeMachine = "1";
    // this.generalService.dialogOpend = this.generalService.dialog.open(AvtListeMachineComponent, new MatDialogConfig());
    // this.generalService.machineChoisie = null;
    // this.generalService.dialogOpend.afterClosed().subscribe(() =>
    // {
    //   this.generalService.fenetreAvtListeMachine = null;
    //   if(this.generalService.isNotEmpty(this.generalService.machineChoisie))
    //   {
    //     this.param_code = this.generalService.machineChoisie.Machine_Code;
    //     if(this.typeTrs == "1")
    //       this.typeTrs = "2"
    //     this.init();
    //   }
    // });
    // this.router.navigate(['avt/liste/machine/1']);
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.param_code = params['param_code'];
      this.typeTrs = params['typeTrs'];
      this.init();
    });
  }
}
